// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TGetHouseOfferHistoryDesktopRequest,
  TGetHouseOfferHistoryDesktopModel,
  IMappers,
  TGetHouseOfferHistoryDesktopResponse_,
  TGetHouseOfferHistoryDesktopResponse,
  TGetHouseOfferHistoryDesktopResponse_1,
  TGetHouseOfferHistoryDesktopResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';

export function createGetHouseOfferHistoryDesktopModel(
  parameters: TGetHouseOfferHistoryDesktopRequest,
): TGetHouseOfferHistoryDesktopModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'valuation-offer-history',
    pathApi: '/v4/get-house-offer-history-desktop/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetHouseOfferHistoryDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetHouseOfferHistoryDesktopRequest;
}

export async function fetchGetHouseOfferHistoryDesktop<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetHouseOfferHistoryDesktopOptions<TResponse200, TResponse400>): Promise<
  TGetHouseOfferHistoryDesktopResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetHouseOfferHistoryDesktopModel(parameters),
    config,
  )) as FetchResponse<TGetHouseOfferHistoryDesktopResponse_>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TGetHouseOfferHistoryDesktopResponse_1, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as TGetHouseOfferHistoryDesktopResponseError, headers);
    }
  }
  return {
    statusCode,
    response,
    headers: Array.from(headers),
  } as TGetHouseOfferHistoryDesktopResponse;
}
